import React from 'react'
import { ConsequenceAndProbabilityRisk } from '../../../api/schemas/schema'
import { ReadOnlyModal } from '../../common/modal/ReadOnlyModal'
import { t } from '../../../i18n/i18n'

type ModalRiskViewProps = {
   risk?: ConsequenceAndProbabilityRisk
   onClose: () => void
}

// Read-only view of a risk on the overview. Shares its shell with ModalActivityView so the
// two cards on the overview look the same.
export const ModalRiskView = ({ risk, onClose }: ModalRiskViewProps) => {
   if (!risk) return null

   const fields = [
      { label: t('ConsequenceDescription'), value: risk.consequence },
      { label: t('RiskSource'), value: risk.source },
      { label: t('WeaknessesOrCurrentProtection'), value: risk.currentState },
      { label: t('UnderlyingMotivationAndStand'), value: risk.underlyingMotivation },
   ]

   return <ReadOnlyModal open={!!risk} title={risk.scenario ?? ''} fields={fields} onClose={onClose} />
}
